<template>
<div>
  <a-card>
    <a-tabs default-active-key="1" @change="changeTabs">
      <a-tab-pane v-for="item in status" :key="item.value" :tab="item.label">
        <template v-if="item.value == 1">
          <a-table :columns="columns" :data-source="data" :row-selection="rowSelection">
            <template slot="img" slot-scope="text">
              <a>{{ text }}</a>
            </template>
            <span slot="action">
              <a @click="showModal">查看</a>
              <a-divider type="vertical" />
              <a>撤回</a>
            </span>
          </a-table>
        </template>
        <template v-if="item.value == 2">
          <div :class="advanced ? 'search' : null">
            <a-form layout="horizontal">
              <div :class="advanced ? null : 'fold'">
                <a-row>
                  <a-col :md="6" :sm="24">
                    <a-form-item
                      label="学院"
                      :labelCol="{ span: 5 }"
                      :wrapperCol="{ span: 18, offset: 1 }"
                    >
                      <a-select placeholder="请选择">
                        <a-select-option value="1">关闭</a-select-option>
                        <a-select-option value="2">运行中</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item
                      label="班级"
                      :labelCol="{ span: 5 }"
                      :wrapperCol="{ span: 18, offset: 1 }"
                    >
                      <a-select placeholder="请选择">
                        <a-select-option value="1">关闭</a-select-option>
                        <a-select-option value="2">运行中</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item
                      label="学历"
                      :labelCol="{ span: 5 }"
                      :wrapperCol="{ span: 18, offset: 1 }"
                    >
                      <a-select placeholder="请选择">
                        <a-select-option value="1">关闭</a-select-option>
                        <a-select-option value="2">运行中</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item
                      label="姓名/学号"
                      :labelCol="{ span: 5 }"
                      :wrapperCol="{ span: 18, offset: 1 }"
                    >
                      <a-input placeholder="请输入" />
                    </a-form-item>
                  </a-col>
                </a-row>
              </div>
              <span style="float: right; margin-top: 3px">
                <a-button type="primary">查询</a-button>
                <a-button style="margin-left: 8px">重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-form>
          </div>

          <div class="btn-group">
            <a-button>批量通过</a-button>
          </div>
          <a-table :columns="columns2" :data-source="data" :row-selection="rowSelection">
            <template slot="img" slot-scope="text">
              <a>{{ text }}</a>
            </template>
            <span slot="action">
              <a>通过</a>
              <a-divider type="vertical" />
              <a @click="showNoPass">打回</a>
            </span>
          </a-table>
        </template>
        <template v-if="item.value == 3">
          <div :class="advanced ? 'search' : null">
            <a-form layout="horizontal">
              <div :class="advanced ? null : 'fold'">
                <a-row>
                  <a-col :md="6" :sm="24">
                    <a-form-item
                      label="学院"
                      :labelCol="{ span: 5 }"
                      :wrapperCol="{ span: 18, offset: 1 }"
                    >
                      <a-select placeholder="请选择">
                        <a-select-option value="1">关闭</a-select-option>
                        <a-select-option value="2">运行中</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item
                      label="班级"
                      :labelCol="{ span: 5 }"
                      :wrapperCol="{ span: 18, offset: 1 }"
                    >
                      <a-select placeholder="请选择">
                        <a-select-option value="1">关闭</a-select-option>
                        <a-select-option value="2">运行中</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item
                      label="学历"
                      :labelCol="{ span: 5 }"
                      :wrapperCol="{ span: 18, offset: 1 }"
                    >
                      <a-select placeholder="请选择">
                        <a-select-option value="1">关闭</a-select-option>
                        <a-select-option value="2">运行中</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :md="6" :sm="24">
                    <a-form-item
                      label="姓名/学号"
                      :labelCol="{ span: 5 }"
                      :wrapperCol="{ span: 18, offset: 1 }"
                    >
                      <a-input placeholder="请输入" />
                    </a-form-item>
                  </a-col>
                </a-row>
              </div>
              <span style="float: right; margin-top: 3px">
                <a-button type="primary">查询</a-button>
                <a-button style="margin-left: 8px">重置</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-form>
          </div>

          <div class="btn-group flex-between">
            <div class="c-tabs">
              <span class="c-tabs-active">全部状态</span>
              <span>已通过</span>
              <span>已打回</span>
            </div>
            <a-button>
              <a-icon type="arrow-down" />导出
            </a-button>
          </div>
          <a-table :columns="columns" :data-source="data" :row-selection="rowSelection">
            <template slot="img" slot-scope="text">
              <a>{{ text }}</a>
            </template>
            <span slot="action">
              <a @click="showModal">审核记录</a>
            </span>
          </a-table>
        </template>
      </a-tab-pane>
    </a-tabs>
  </a-card>

  <a-modal v-model="visible" title="审核记录" :footer="null">
      <div class="from"><label for="">审核人:</label> <div >
        <p>陈旭（通过 2022/03/20 15:00:00）</p>
        <p>王旭（待审核）</p>
      </div>  </div>
      
    </a-modal>
    <a-modal v-model="noPassVisible" title="打回">
      <div class="from"><label for="">原因:</label>
      <a-textarea
      v-model="value"
      placeholder="请输入打回原因"
      :auto-size="{ minRows: 5, maxRows: 8 }"
    />
       </div>
      
    </a-modal>
    </div>
</template>

<script>
const columns = [
  {
    title: "学号",
    dataIndex: "name",
  },
  {
    title: "姓名",
    dataIndex: "img",
  },
  {
    title: "学院",
    dataIndex: "address",
  },
  {
    title: "班级（专业）",
    dataIndex: "address",
  },
  {
    title: "学历",
    dataIndex: "img",
  },
  {
    title: "入住床位",
    dataIndex: "address",
  },
  {
    title: "毕业类型",
    dataIndex: "address",
  },
  {
    title: "身份证号",
    dataIndex: "img",
  },
  {
    title: "部门",
    dataIndex: "address",
  },
  {
    title: "事项",
    dataIndex: "address",
  },
  {
    title: "提交人",
    dataIndex: "address",
  },
  {
    title: "提交时间",
    dataIndex: "time",
  },
  {
    title: "审核人",
    dataIndex: "address",
  },
  {
    title: "审核时间",
    dataIndex: "time",
  },
  {
    title: "状态",
    dataIndex: "satus",
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: {
      customRender: "action",
    },
  },
];

const columns2 = [
  {
    title: "学号",
    dataIndex: "name",
  },
  {
    title: "姓名",
    dataIndex: "img",
  },
  {
    title: "学院",
    dataIndex: "address",
  },
  {
    title: "班级（专业）",
    dataIndex: "address",
  },
  {
    title: "学历",
    dataIndex: "img",
  },
  {
    title: "入住床位",
    dataIndex: "address",
  },
  {
    title: "毕业类型",
    dataIndex: "address",
  },
  {
    title: "身份证号",
    dataIndex: "img",
  },
  {
    title: "部门",
    dataIndex: "address",
  },
  {
    title: "事项",
    dataIndex: "address",
  },
  {
    title: "提交人",
    dataIndex: "address",
  },
  {
    title: "提交时间",
    dataIndex: "time",
  },
  {
    title: "操作",
    key: "action",
    scopedSlots: {
      customRender: "action",
    },
  },
];

const data = [
  {
    key: 1,
    name: "John Brown sr.",
    age: 60,
    address: "New Y",
  },
  {
    key: 2,
    name: "Joe Black",
    age: 32,
    address: "Sidne",
  },
];

const status = [
  {
    value: "1",
    label: "我发起",
  },
  {
    value: "2",
    label: "待审核",
  },
  {
    value: "3",
    label: "已审核",
  },
];

const rowSelection = {
  onChange: (selectedRowKeys, selectedRows) => {
    console.log(
      `selectedRowKeys: ${selectedRowKeys}`,
      "selectedRows: ",
      selectedRows
    );
  },
  onSelect: (record, selected, selectedRows) => {
    console.log(record, selected, selectedRows);
  },
  onSelectAll: (selected, selectedRows, changeRows) => {
    console.log(selected, selectedRows, changeRows);
  },
};
export default {
  name: "BannerManagement",
  data() {
    return {
      advanced: true,
      status,
      data,
      columns,
      columns2,
      rowSelection,
      visible:false,
      noPassVisible:false,
    };
  },
  methods: {
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    changeTabs(key) {
      console.log(key);
    },
    showModal() {
      this.visible = true;
    },
    showNoPass(){
      this.noPassVisible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 54px;
}
.fold {
  width: calc(100% - 216px);
  display: inline-block;
}
.operator {
  margin-bottom: 18px;
}
@media screen and (max-width: 900px) {
  .fold {
    width: 100%;
  }
}
</style>
